import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sw-card sw-card--pad"
}
const _hoisted_2 = { class: "form-section__head" }
const _hoisted_3 = { class: "swois-ecard__l-title" }
const _hoisted_4 = {
  key: 0,
  class: "swois-ecard__l-desc form-section__desc"
}
const _hoisted_5 = {
  key: 1,
  class: "sw-card sw-card--pad swois-ecard"
}
const _hoisted_6 = { class: "swois-ecard__l" }
const _hoisted_7 = { class: "swois-ecard__l-title" }
const _hoisted_8 = {
  key: 0,
  class: "swois-ecard__l-desc form-section__desc"
}
const _hoisted_9 = { class: "swois-ecard__r" }


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseFormSection',
  props: {
    title: {},
    description: {},
    stacked: { type: Boolean }
  },
  setup(__props: any) {

// SWOIS design-system form section — shared by every edit/create screen
// (courses, events, …). Two layouts:
// - default: title + subtitle in the left column, content slot on the right.
// - stacked: title + subtitle header on top, content slot full-width below
//   (e.g. a list/table that needs the whole width).
// In both layouts the subtitle sits directly under the title.


return (_ctx: any,_cache: any) => {
  return (__props.stacked)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1),
          (__props.description)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.description), 1))
            : _createCommentVNode("", true)
        ]),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]))
    : (_openBlock(), _createElementBlock("section", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(__props.title), 1),
          (__props.description)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(__props.description), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ]))
}
}

})